import { useTranslation } from "react-i18next";
import { PartnerCountry, Product } from "~/common/props/orchestrator";
import { formatCurrency } from "@commons-monorepo/index";
import { priceCalculator, priceWithWholesale } from "@commons-monorepo/index";
import { ToppingValueDto } from "../../../../Product.type";
import styles from "./product-cloud-prices.module.css";

export const ProductCloudPrices = ({
  product,
  country,
  toppings,
  className





}: {product: Product;country: PartnerCountry;toppings: ToppingValueDto[];className?: string;}) => {
  const { t } = useTranslation();

  const price = priceCalculator(product, toppings);
  const priceFull = priceCalculator(product, toppings, 1, true);
  const priceWholesale = priceWithWholesale(product, toppings);

  return price > 0 ?
  <div className={`${styles.productSkin1Prices} ${className || ""}`}>
      <div
      className={`${styles.productDetailPricesContainer} ${
      !product?.wholesale?.configurations ?
      styles.productDetailPrices__withoutwholesale :
      ""
      }`}>

        <div className={`${styles.productDetailPrice}`}>
          <h2 className={`${styles.productDetailPriceTitle}`}>
            {t(!!product.kit ? "product.priceKit" : "product.price")}{" "}
            {product?.wholesale?.configurations &&
          t("product.b2c.unit_extended")}
          </h2>
          {product?.priceWithDiscount &&
        <p className={`${styles.productDetailPriceDiscount}`}>
              {formatCurrency(priceFull, country)}
            </p>}

          <p className={`${styles.productDetailPriceValue}`}>
            {formatCurrency(price, country)}
            {product?.priceWithDiscount &&
          <span className={`${styles.priceValueDiscount}`}>
                -{product.percentageDiscount}%
              </span>}

          </p>
        </div>
      </div>
      {priceWholesale &&
    <div className={`${styles.productDetailPricesContainer}`}>
          {(product?.wholesale?.configurations || []).map(
        (wholesale, index) =>
        <div
          className={`${styles.productDetailPrice}`}
          key={`product-detail-price-${index}`}>

                <h2 className={`${styles.productDetailPriceTitle}`}>
                  {t("product.b2c.price_extended")}
                </h2>
                {product?.priceWithDiscount &&
          <p className={`${styles.productDetailPriceDiscount}`}>
                    {formatCurrency(price || 0, country)}
                  </p>}

                <p className={`${styles.productDetailPriceValue}`}>
                  {formatCurrency(priceWholesale, country)}
                  {product?.priceWithDiscount &&
            <span className={`${styles.priceValueDiscount}`}>
                      -{product.percentageDiscount}%
                    </span>}

                </p>
                <p className={`${styles.productDetailWholesaleMin}`}>
                  {t("product.b2c.min_units").replace(
              "{replace}",
              wholesale.minUnits.toString() || ""
            )}
                </p>
              </div>

      )}
        </div>}

    </div> :
  null;
};